/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Bodyfat_Range_AnchorInputs */

const en_us2_body_assessment_bodyfat_range_anchor = /** @type {(inputs: Body_Assessment_Bodyfat_Range_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The range is narrower because you gave a reference reading of your own.`)
};

const pt_br2_body_assessment_bodyfat_range_anchor = /** @type {(inputs: Body_Assessment_Bodyfat_Range_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A faixa está mais estreita porque você informou uma medição de referência sua.`)
};

const es_419_body_assessment_bodyfat_range_anchor = /** @type {(inputs: Body_Assessment_Bodyfat_Range_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El rango es más estrecho porque diste una medición de referencia propia.`)
};

const pt_pt2_body_assessment_bodyfat_range_anchor = /** @type {(inputs: Body_Assessment_Bodyfat_Range_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O intervalo é mais estreito porque indicaste uma medição de referência tua.`)
};

const fr_fr2_body_assessment_bodyfat_range_anchor = /** @type {(inputs: Body_Assessment_Bodyfat_Range_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fourchette est plus étroite parce que tu as fourni ta propre mesure de référence.`)
};

const de_de2_body_assessment_bodyfat_range_anchor = /** @type {(inputs: Body_Assessment_Bodyfat_Range_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Spanne ist enger, weil du eine eigene Referenzmessung angegeben hast.`)
};

const it_it2_body_assessment_bodyfat_range_anchor = /** @type {(inputs: Body_Assessment_Bodyfat_Range_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intervallo è più stretto perché hai inserito una tua misurazione di riferimento.`)
};

/**
* | output |
* | --- |
* | "The range is narrower because you gave a reference reading of your own." |
*
* @param {Body_Assessment_Bodyfat_Range_AnchorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_bodyfat_range_anchor = /** @type {((inputs?: Body_Assessment_Bodyfat_Range_AnchorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Bodyfat_Range_AnchorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_bodyfat_range_anchor(inputs)
	if (locale === "es-419") return es_419_body_assessment_bodyfat_range_anchor(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_bodyfat_range_anchor(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_bodyfat_range_anchor(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_bodyfat_range_anchor(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_bodyfat_range_anchor(inputs)
	return en_us2_body_assessment_bodyfat_range_anchor(inputs)
});
export { body_assessment_bodyfat_range_anchor as "body-assessment.bodyfat_range_anchor" }